import { html, css } from "lit";
import { customElement, property } from "lit/decorators.js";

import { LoanLightElement } from "@/legacy-components/loanlight-element";
import { getSvg } from "@/utils/getSvgs";
import { handleUnsafeHtml } from "@/utils/handleUnsafeHtml";

@customElement("loanlight-top-bar")
export class LoanLightTopBar extends LoanLightElement {
  @property({ type: String }) declare backgroundColor: string;

  constructor() {
    super();
    this.backgroundColor = "#091f2f";
  }
  static styles = css`
    .top-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      padding: 16px 32px;
    }

    .top-bar__left {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .top-bar__right {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    ::slotted([slot="left"]),
    ::slotted([slot="right"]) {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  `;

  render() {
    return html`
      <div class="top-bar" style="background-color: ${this.backgroundColor}">
        <div class="top-bar__left">
          <div class="top-bar__logo">
            ${handleUnsafeHtml(getSvg("loanLightLogoLightSvg"))}
          </div>
          <slot name="left"></slot>
        </div>
        <div class="top-bar__right">
          <slot name="right"></slot>
        </div>
      </div>
    `;
  }
}
